import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { FormBuilder } from '@angular/forms'

import {
  CaseCreateEditComponent,
  ResourceDefinition,
  Field,
  InputType,
  BreadcrumbService,
  FlashMessageService,
  ResourceService,
  caseCreateEditTemplate
} from '@case-app/angular-library'

import { corporateGroupDefinition } from '../corporate-group.definition'

@Component({ template: caseCreateEditTemplate })
export class CorporateGroupCreateEditComponent
  extends CaseCreateEditComponent
  implements OnInit
{
  definition: ResourceDefinition = corporateGroupDefinition
  fields: Field[] = [
    {
      label: 'Nom',
      property: 'name',
      inputType: InputType.Text
    }
  ]

  constructor(
    formBuilder: FormBuilder,
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService
  ) {
    super(
      formBuilder,
      router,
      breadcrumbService,
      resourceService,
      flashMessageService,
      activatedRoute
    )
  }

  ngOnInit() {
    this.initCreateEditView()
  }
}
